import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatStepperModule} from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { NgxFileDropModule } from 'ngx-file-drop';

//// FUSE
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseDemoModule } from '@fuse/components/demo/demo.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';

import { NgxChartsModule } from '@swimlane/ngx-charts';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SWEETALERT
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

/// COMPONENTES
import { WizardCGOComponent } from 'app/main/wizard-cgo/wizard-cgo.component';

// CERTIFICAR
//idiomas
import { IdiomasComponent } from 'app/main/pagina/productos/certificar/tipo_2/idiomas/idiomas.component';
import { IdiomasModule } from 'app/main/pagina/productos/certificar/tipo_2/idiomas/idiomas.module';

//FORALL
import { ForAllModule } from "app/main/pagina/productos/certificar/tipo_2/for-all/for-all.module";
import { ForAllComponent } from "app/main/pagina/productos/certificar/tipo_2/for-all/for-all.component";

//CREAR ENCUESTA
import { CreacionModule } from 'app/main/pagina/productos/certificar/tipo_2/crear-encuesta/creacion.module';
import { CreacionComponent } from 'app/main/pagina/productos/certificar/tipo_2/crear-encuesta/creacion.component';

//EDITAR ENCUESTA
import { EditorEncuestaModule } from 'app/main/pagina/productos/certificar/tipo_2/editor-encuesta/editor-encuesta.module';
import { EditorEncuestaComponent } from 'app/main/pagina/productos/certificar/tipo_2/editor-encuesta/editor-encuesta.component';

//COLABORADORES
import { ColaboradoresModule } from 'app/main/pagina/productos/certificar/tipo_2/colaboradores/colaboradores.module';
import { ColaboradoresComponent } from 'app/main/pagina/productos/certificar/tipo_2/colaboradores/colaboradores.component';

//PROGRAMACION
import { ProgramacionModule } from 'app/main/pagina/productos/certificar/tipo_2/programacion/programacion.module';
import { ProgramacionComponent } from 'app/main/pagina/productos/certificar/tipo_2/programacion/programacion.component';

//ENVIO
import { DispatchComponent } from 'app/main/pagina/productos/certificar/tipo_2/dispatch/dispatch.component';

//SURVEY ESTATUS
import { EstatusEncuestaModule } from "app/main/pagina/productos/certificar/tipo_2/estatus-encuesta/estatus-encuesta.module";
import { EstatusEncuestaComponent } from 'app/main/pagina/productos/certificar/tipo_2/estatus-encuesta/estatus-encuesta.component';

//CLOSE
import { ProjectDashboardComponent,FechasRecordatoriosComponent } from 'app/main/pagina/productos/certificar/tipo_2/cierre/cierre.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

///PREGUNTAS SECCIONES EN VERSIONES 3.0
import { PreguntasModule } from "app/main/pagina/productos/certificar/tipo_2/preguntas/preguntas.module";
import { ReactivosV3Component } from "app/main/pagina/productos/certificar/tipo_2/preguntas/reactivos-v3/reactivos-v3.component";
import { TemplateAdminComponent } from "app/main/pagina/productos/certificar/tipo_2/template-admin/template-admin.component";

// CONFIGURACION DE VOZ
import { ConfiguracionVozComponent } from "app/main/pagina/productos/certificar/tipo_2/configuracion-voz/configuracion-voz.component";

const rutasHijasProdsV3 = [
  { path: '', redirectTo: 'languages', pathMatch: 'full'  },
  { path: 'languages', component: IdiomasComponent, canActivate: [AuthGuard] },
  { path: 'voice', component: ConfiguracionVozComponent, canActivate: [AuthGuard] },
  { path: 'templates', component: TemplateAdminComponent,canActivate: [AuthGuard] },
  { path: 'ForAll', component: ForAllComponent, canActivate: [AuthGuard] },
  { path: 'crearencuesta', component: CreacionComponent, canActivate: [AuthGuard]},
  { path: 'surveyEditor', component: EditorEncuestaComponent, canActivate: [AuthGuard] },
  { path: 'collaborators', component: ColaboradoresComponent, canActivate: [AuthGuard] },
  { path: 'schedule', component: ProgramacionComponent, canActivate: [AuthGuard] },
  { path: 'mailSending', component: DispatchComponent, canActivate: [AuthGuard] },
  { path: 'statusSurveys', component: EstatusEncuestaComponent, canActivate: [AuthGuard] },
  { path: 'close', component: ProjectDashboardComponent, canActivate: [AuthGuard] },
  ///////nuevas preguntas
  { path: 'reactivosv3', component: ReactivosV3Component, canActivate: [AuthGuard] },
  { path: 'nps', component: ReactivosV3Component, data: { tipoSeccion: 1 }, canActivate: [AuthGuard] },
  { path: 'reactives', component: ReactivosV3Component, data: { tipoSeccion: 2 }, canActivate: [AuthGuard] },
  { path: 'control', component: ReactivosV3Component, data: { tipoSeccion: 3 }, canActivate: [AuthGuard] },
  { path: 'demographics', component: ReactivosV3Component, data: { tipoSeccion: 4 }, canActivate: [AuthGuard] },
  { path: 'open', component: ReactivosV3Component, data: { tipoSeccion: 5 }, canActivate: [AuthGuard] },
  // { path: 'ForAll', component: ReactivosV3Component, data: { tipoSeccion: 6 }, canActivate: [AuthGuard] },
  { path: 'additionals', component: ReactivosV3Component, data: { tipoSeccion: 7 }, canActivate: [AuthGuard] },
];

const rutas: Routes=[
  {
    path     : 'certify_t3/wizard',
    component: WizardCGOComponent,
    data : {producto : 'c3'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'measurement_t7/wizard',
    component: WizardCGOComponent,
    data : {producto : 'm7'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'measurement_t8/wizard',
    component: WizardCGOComponent,
    data : {producto : 'm7'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'measurement_t9/wizard',
    component: WizardCGOComponent,
    data : {producto : 'm7'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'pulse_t1/wizard',
    component: WizardCGOComponent,
    data : {producto : 'p1'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'focus_t1/wizard',
    component: WizardCGOComponent,
    data : {producto : 'f1'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'amco_1/wizard',
    component: WizardCGOComponent,
    data : {producto : 'am1'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'traba_digno/wizard',
    component: WizardCGOComponent,
    data : {producto : 'td1'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'prime_emple/wizard',
    component: WizardCGOComponent,
    data : {producto : 'pe1'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'certify_t4/wizard',
    component: WizardCGOComponent,
    data : {producto : 'c4Plata'},
    children: rutasHijasProdsV3
  },
  {
    path     : 'certify_t6/wizard',
    component: WizardCGOComponent,
    data : {producto : 'c6'},
    children: rutasHijasProdsV3
  },
];

@NgModule({
  declarations: [
    //ENVIO
    DispatchComponent,
    //CLOSE
    ProjectDashboardComponent,
    FechasRecordatoriosComponent,

  ],
  imports     : [
      RouterModule.forChild(rutas),

      MatBadgeModule,
      MatButtonModule,
      MatCheckboxModule,
      MatChipsModule,
      MatStepperModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatExpansionModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatRippleModule,
      MatSelectModule,
      MatSnackBarModule,
      MatTableModule,
      MatSortModule,
      MatToolbarModule,
      MatTooltipModule,
      MatTabsModule,
      MatRadioModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,

      NgxFileDropModule,

      BrowserModule,
      BrowserAnimationsModule,
      DragDropModule,
      MatButtonToggleModule,
      MatCardModule,

      FuseSidebarModule,
      FuseSharedModule,
      FuseDemoModule,
      FuseWidgetModule,
      NgxChartsModule,

      TranslateModule,

      SweetAlert2Module,

      ColaboradoresModule,
      CreacionModule,
      ProgramacionModule,
      ForAllModule,
      PreguntasModule,
      IdiomasModule,
      EditorEncuestaModule,
      NgxMaterialTimepickerModule,
      EstatusEncuestaModule
  ],
  entryComponents: [
    FechasRecordatoriosComponent
  ]
})
export class WizardCertificarT2RutasModule {
    //const routes = this.rutas;
}


//export const routes = RouterModule.forChild(rutas),
